import { format } from 'date-fns';

export function formToBackEndData(formData, res) {
  const neoFormData = {};
  neoFormData.name = formData.Nama;
  neoFormData.nim = parseInt(formData.NIM, 10);
  neoFormData.birth_place = formData['Tempat lahir'];
  neoFormData.birth_date = format(formData['Tanggal lahir'], 'yyyy-MM-dd');
  neoFormData.major = formData.Jurusan;
  neoFormData.email = formData.Email;
  neoFormData.phone_number = formData['Nomor Telepon'];
  neoFormData.ktm = res;
  neoFormData.category = formData['Permintaan Pelayanan'];
  neoFormData.taskresponse_set = formData['taskResponses'];
  return JSON.stringify(neoFormData);
}

export const arrToString = (arr, id = '') => {
  let a = '';
  arr.forEach((element) => {
    a += '.' + `${id}${element}`;
  });
  return a;
};

export const getDate = (date) => {
  return date.slice(0, 10);
};

export function rulesToInfoStr(rules) {
  function checkShouldGetNewLine(string) {
    if (string !== '') {
      return ', ';
    } else {
      return '';
    }
  }

  if (!rules) {
    return '';
  }

  let infoStr = '';

  if (rules.required && rules.required.value) {
    infoStr += 'Wajib diisi';
  }

  if (
    rules.maxLength &&
    rules.minLength &&
    rules.maxLength.value === rules.minLength.value
  ) {
    infoStr += checkShouldGetNewLine(infoStr);
    infoStr += 'Harus sepanjang ' + rules.maxLength.value + ' karakter';
  } else {
    if (rules.maxLength) {
      infoStr += checkShouldGetNewLine(infoStr);
      infoStr += 'Maksimal sepanjang ' + rules.maxLength.value + ' karakter';
    }

    if (rules.minLength) {
      infoStr += checkShouldGetNewLine(infoStr);
      infoStr += 'Minimal sepanjang ' + rules.minLength.value + ' karakter';
    }
  }

  if (rules.pattern) {
    if (String(rules.pattern.value) === '/^[0-9]*$/') {
      infoStr += checkShouldGetNewLine(infoStr);
      infoStr += 'Wajib numerikal';
    }
  }

  if (rules.validateSize) {
    infoStr += checkShouldGetNewLine(infoStr);
    infoStr += 'File wajib dibawah ';

    const rawSize = rules.validateSize.value;
    if (rawSize / 1000000000 > 1) {
      infoStr += String((rawSize / 1000000000).toFixed(2));
      infoStr += ' GB';
    } else if (rawSize / 1000000 > 1) {
      infoStr += String((rawSize / 1000000).toFixed(2));
      infoStr += ' MB';
    } else if (rawSize / 1000 > 1) {
      infoStr += String((rawSize / 1000).toFixed(2));
      infoStr += ' KB';
    } else {
      infoStr += String(rawSize);
      infoStr += ' Bytes';
    }
  }
  if (rules.validateType && rules.validateType.value) {
    infoStr += checkShouldGetNewLine(infoStr);
    infoStr += 'File wajib bertipe ';
    for (let index = 0; index < rules.validateType.value.length; index++) {
      const element = rules.validateType.value[index];
      if (index !== 0) {
        infoStr += '/';
      }
      infoStr += element;
    }
  }
  if (rules.validateNum) {
    infoStr += checkShouldGetNewLine(infoStr);
    infoStr +=
      'File wajib berjumlah kurang dari ' + String(rules.validateType.value);
  }

  return infoStr;
}
